import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SetupPageService } from '@core/services/setup-page/setup-page.service';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
	selector: 'app-leave-modal',
	templateUrl: './leave-modal.component.html',
	styleUrls: ['./leave-modal.component.scss', './leave-modal.responsive.scss'],
})
export class LeaveModalComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<LeaveModalComponent>,
		private countryCodeService: SetupPageService,
		private modalService: ModalService,

		@Inject(MAT_DIALOG_DATA) public data: { embedded: boolean },
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.dialogRef);
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	leave(): void {
		this.countryCodeService.resetOnBeforeUnloadHandler();

		if (this.data.embedded) {
			location.reload();

			return;
		}

		this.countryCodeService.parseLocalLinkHandler();
		this.closeDialog();
	}
}
